/* eslint-disable @next/next/next-script-for-ga */
import Head from 'next/head';

import { Layout } from '@/components/common';
import { Breadcrumbs } from '@/components/ui';
import WidgetWrapper from '@/components/widget-wrapper/WidgetWrapper';
import useIsWebView from '@/hooks/useWebView';

import { SERVER_URL } from '../constants';

export default function Home({ data }) {
  const widgetData = JSON.parse(data);
  const isWebView = useIsWebView();
  return isWebView ? (
    <>
      <Breadcrumbs data={widgetData?.breadcrumbs} />
      <WidgetWrapper widgets={widgetData?.widgets} />
    </>
  ) : (
    <Layout
      navbar={widgetData?.menu}
      footer={widgetData?.footer}
      metadata={widgetData?.metadata}
      appDownload={widgetData?.app_download_widget}
    >
      <Head>
        <title>{widgetData?.metadata?.title || widgetData?.name}</title>
        {widgetData?.metadata?.description && (
          <meta
            name='description'
            content={widgetData?.metadata?.description}
          />
        )}
        <meta
          name='keywords'
          content={
            widgetData?.metadata?.keywords ||
            widgetData?.metadata?.title ||
            'Bakcell'
          }
        />
      </Head>
      <Breadcrumbs data={widgetData?.breadcrumbs} />
      <WidgetWrapper widgets={widgetData?.widgets} />
    </Layout>
  );
}

export const getServerSideProps = async ({ query, locale }) => {
  const languages = ['en', 'az', 'ru'];
  const urlLang = languages.find((x) => query.dynamicPage.includes(x));
  let language = locale;
  if (urlLang) {
    language = urlLang;
  }
  const response = await fetch(
    `${SERVER_URL}/pages/${query.dynamicPage.join('/')}/`,
    {
      headers: {
        'Accept-Language': locale,
      },
    },
  );
  if (!response.ok) {
    const data = await response.json();
    if (response?.status === 308) {
      return {
        redirect: {
          permanent: false,
          destination: `/${language}/${data.slug}`,
        },
      };
    }
    return {
      notFound: true,
    };
  }
  const data = await response.text();
  return {
    props: {
      data,
    },
  };
};
